import React from "react";

const Button = React.forwardRef((props, ref) => {
  let buttonText;
  if (props.isAdding) {
    buttonText = "Saving...";
  } else {
    buttonText = props.children || props.text;
  }
  return (
    <button
      {...props}
      ref={ref}
      onClick={props.onClick}
      disabled={props.isAdding || props.isDisabled || props.disabled || false}
      style={{
        ...props?.style,
        color: props?.color,
        fontSize: props?.fSize,
        padding: props?.padding,
        border: props?.border,
        backgroundColor: props?.backgroundColor,
      }}
    >
      {buttonText}
    </button>
  );
});

export default Button;
